import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false, className = "" }) => (
  <span
    className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] ${dark ? "text-brand" : "text-brand-700"} ${className}`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-brand" />
    {children}
  </span>
);
